import './App.css';
import Hero from './components/Hero/Hero';
import Programs from './components/Programs/Programs';
import Reasons from './components/Reasons/Reasons';
import Plans from './components/Plans/Plans'
import Join from './components/Join/Join';
import Footer from './components/Footer/Footer';
import Header from './components/Header/Header';
import PrivacyPolicy from './components/Legal/PrivacyPolicy';
import TermsConditions from './components/Legal/TermsConditions';
import Eula from './components/Legal/Eula';
import CommunityGuidelines from './components/Legal/CommunityGuidelines';
import Support from './components/Legal/Support';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import { useEffect, useState } from 'react';

function App() {
  const normalizePath = (p) => {
    if (!p || p === '/') return '/';
    // Remove leading/trailing whitespace and slashes, then lowercase
    return p.trim().replace(/\/+$/, '').toLowerCase();
  };

  const [path, setPath] = useState(normalizePath(window.location.pathname));

  useEffect(() => {
    // This allows us to handle clicks if we use the history API later
    const handleLocationChange = () => {
      setPath(normalizePath(window.location.pathname));
    };
    window.addEventListener('popstate', handleLocationChange);
    return () => window.removeEventListener('popstate', handleLocationChange);
  }, []);

  const renderContent = () => {
    if (path === '/privacy') {
      return <PrivacyPolicy />;
    } else if (path === '/terms') {
      return <TermsConditions />;
    } else if (path === '/eula') {
      return <Eula />;
    } else if (path === '/community-guidelines') {
      return <CommunityGuidelines />;
    } else if (path === '/support') {
      return <Support />;
    } else {
      return (
        <>
          <Hero/>
          <Programs/>
          <Reasons/>
          <Plans/>
          <Join/>
        </>
      );
    }
  };

  return (
    <div className={`App ${path !== '/' && path !== '' ? 'legal-page' : ''}`}>
       {/* Always show Header and Footer as requested */}
      <Header isHome={path === '/' || path === ''} />
      {renderContent()}
      <ScrollToTop />
      <Footer />
    </div>
  );
}

export default App;
